exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".StatisticReports .question-container{max-width:750px}.StatisticReports .qbm-accordion-content{border:1px solid #d1d1d1}.StatisticReports .qbm-accordion-content__item{display:flex;justify-content:space-between}.StatisticReports .qbm-accordion-content__item .marker-published{min-width:10px;height:10px;border-radius:10px;background:#52c41a}.StatisticReports .qbm-accordion-content__item .marker-unpublished{width:10px;height:10px;border-radius:10px;background:#fa541c}.ReportTable .ant-table-row{cursor:pointer}.Reports .question-types-block{display:flex;flex-direction:column}.Reports .btn-actions{display:flex}.Reports .table-data{margin-top:20px}.Reports .table-data .actions{display:flex;align-items:center;flex-direction:row;color:#00adff}.Reports .table-data .actions .far{margin-right:10px;cursor:pointer}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./yii2/frontend/frontend-assets/src/components/StatisticReports/style.scss
// module id = 5020
// module chunks = 0